import React from "react";
import { editorial, utility } from '../utils/tokens'; 

const Typography = ({ variant, type = "editorial", children, as = "p", style = {} }) => {
    const styles = type === "utility" ? utility[variant] : editorial[variant];

    // Merge inline styles with default typography styles
    const combinedStyles = { margin: 0, ...styles, ...style };

    return React.createElement(as, { style: combinedStyles }, children);
};

export default Typography;

